// amplitude.js

function amplitudeEvents() {
    // Boot data stays inside here (copied from Laravel blade injection)
    const BOOT = window?.AMPLITUDE_BOOT || null;

    if (!BOOT || !BOOT.apiKey) {
        console.warn('Amplitude boot data missing — skipping initialization.');
        return null;
    }

    const amplitude = window.amplitude;
    if (!amplitude) {
        console.error('Amplitude SDK failed to load.');
        return null;
    }

    const EVENT_NAMES = {
        ALWAYS_ON_ANALYTICS_LOAD: 'always_on_analytics_load',
        ALWAYS_ON_ANALYTICS_LANGUAGE_FILTER: 'always_on_analytics_language_filter',
        ALWAYS_ON_ANALYTICS_PRINT: 'always_on_analytics_print',
        ALWAYS_ON_ANALYTICS_REPORT_EMAILED: 'always_on_analytics_report_emailed',
        ALWAYS_ON_ANALYTICS_SUBSITES_FILTERED: 'always_on_analytics_subsites_filtered',
        ALWAYS_ON_ANALYTICS_DATES_FILTERED: 'always_on_analytics_dates_filtered',
        ALWAYS_ON_ANALYTICS_TOP_QUESTIONS_EXPANDED: 'always_on_analytics_top_questions_expanded',
    };

    // Initialize Amplitude
    amplitude.init(BOOT.apiKey, {
        autocapture: true,
        fetchRemoteConfig: true,
    });

    function initUserProperties() {
        const identifyEvent = new amplitude.Identify();
        const props = BOOT.user || {};

        for (const key in props) {
            if (props[key] !== null && props[key] !== undefined) {
                identifyEvent.set(key, props[key]);
            }
        }

        amplitude.identify(identifyEvent);
    }

    const Events = {
        names: EVENT_NAMES,

        trackAnalyticsLoaded(key, eventProperties) {
            const userKey =
                (BOOT.user?.['user_id.always_on']
                    ? 'user_' + BOOT.user['user_id.always_on']
                    : '') + '_' + key;

            if (!sessionStorage.getItem(userKey)) {
                sessionStorage.setItem(userKey, '1');
                amplitude.track(EVENT_NAMES.ALWAYS_ON_ANALYTICS_LOAD, eventProperties);
            }
        },

        trackLanguageFilter(lang, eventProperties) {
            amplitude.track(EVENT_NAMES.ALWAYS_ON_ANALYTICS_LANGUAGE_FILTER, {
                ...eventProperties,
                always_on_analytics_language: lang,
            });
        },

        trackPrint(eventProperties) {
            amplitude.track(EVENT_NAMES.ALWAYS_ON_ANALYTICS_PRINT, eventProperties);
        },

        trackReportEmailed(eventProperties) {
            amplitude.track(EVENT_NAMES.ALWAYS_ON_ANALYTICS_REPORT_EMAILED, eventProperties);
        },

        trackSubsitesFiltered(subsites, eventProperties) {
            amplitude.track(EVENT_NAMES.ALWAYS_ON_ANALYTICS_SUBSITES_FILTERED, {
                ...eventProperties,
                alwayson_analytics_subsites: subsites.join(','),
            });
        },

        trackDatesFiltered(startDate, endDate, eventProperties) {
            const msPerDay = 24 * 60 * 60 * 1000;
            const diffDays =
                Math.round((new Date(endDate) - new Date(startDate)) / msPerDay) + 1;

            amplitude.track(EVENT_NAMES.ALWAYS_ON_ANALYTICS_DATES_FILTERED, {
                ...eventProperties,
                alwayson_analytics_start_date: startDate,
                alwayson_analytics_end_date: endDate,
                alwayson_analytics_date_count: diffDays,
            });
        },

        trackTopQuestionExpanded(question, eventProperties) {
            amplitude.track(EVENT_NAMES.ALWAYS_ON_ANALYTICS_TOP_QUESTIONS_EXPANDED, {
                ...eventProperties,
                alwayson_analytics_question: question,
            });
        },
    };

    try {
        initUserProperties();
    } catch (err) {
        console.error('Amplitude init failed', err);
    }

    return Events;
}

export {amplitudeEvents};
